import * as React from "react";
import type { SVGProps } from "react";
const SvgQuotation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#quotation_svg__a)">
      <path d="M6 19a1 1 0 0 1-.27-1.97A3.75 3.75 0 0 0 9 13v-1H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a5.72 5.72 0 0 1-4.76 6zM6 7v3h3V7zM15 19a1 1 0 0 1-.27-1.97A3.75 3.75 0 0 0 18 13v-1h-3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a5.72 5.72 0 0 1-4.76 6zm0-12v3h3V7z" />
    </g>
    <defs>
      <clipPath id="quotation_svg__a">
        <path fill="#fff" d="M4 5h16v14H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgQuotation;
